import styled from "styled-components"
import Colors from "utils/Colors"

export default styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 1rem;
`

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-itens: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  min-height: 70vh;
  & span {
    margin: 0 auto;
  }
  & span:last-child {
    font-size: 2.5rem;
    color: ${Colors.primaryColor};
  }
`
export const IconLabel = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-weight: bold;
  text-transform: capitalize;
  color: #FFFFFF;
  background-color: #424242;
  width: 10rem;
  padding: 0.5rem 0.25rem;
  border-radius: 4px;
  font-size: 12px;
` 
export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  width: 100%;
  height: 100%;
`
export const AreaContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-itens: flex-start;
  justify-content: flex-start;
  width: 100%;
  margin-top: 2rem;
  & > h3{
    color: ${Colors.loginLigthenPrimaryColor}
  }
`


export const styles = {
  gappedItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    width: '100%',
  },
  largeGap: {
    gap: '3rem',
  },
}


